module.exports = __webpack_public_path__ + "static/media/c1.ff724b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/compliance/c1.png
// module id = 508
// module chunks = 0